import { IApiResponse } from "../../../@types/api-response.type";
import { ILastSync } from "../../../@types/last-sync.type";
import { getErrorMessage } from "../../../utils/utils";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";

export const getLastSync = async (systemName: string): Promise<ILastSync | ApiException> => {
  try {
    const { data } = await Api.get<IApiResponse<ILastSync>>(`/GetLastSync`, {
      params: { systemName },
    });
    return data.result;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao verificar ultima sincronização'))
  }
};

export const getIsSyncNow = async (systemName: string): Promise<boolean | ApiException> => {
  try {
    const { data } = await Api.get<IApiResponse<string>>(`/GetIsSyncNow`, {
      params: { systemName },
    });
    return data.result == "true";
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao verificar se a sincronização está em andamento'))
  }
};
